module.exports = __webpack_public_path__ + "media/Johnny Drille  Ft Simi - Halleluya.b3286cba.mp3";